import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { MoreVertical20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/MoreVertical20Regular";

export function useMenuItem_More(
    menuItem_Checkout: IContextualMenuItem,
    menuItem_Checkin: IContextualMenuItem,
    menuItem_DiscardCheckout: IContextualMenuItem,
    menuItem_Publish: IContextualMenuItem,
    menuItem_Unpublish: IContextualMenuItem,
    menuItem_VersionAppRej: IContextualMenuItem,
) {
    const languageStrings = React.useContext(LanguageContext);

    const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);

    const menuItem_More = React.useMemo(() => {
        const subMenuItems: IContextualMenuItem[] = [];
        if (menuItem_Checkout) {
            subMenuItems.push(menuItem_Checkout);
        }

        if (menuItem_Checkin) {
            subMenuItems.push(menuItem_Checkin);
        }

        if (menuItem_DiscardCheckout) {
            subMenuItems.push(menuItem_DiscardCheckout);
        }

        if (menuItem_Publish) {
            subMenuItems.push(menuItem_Publish);
        }

        if (menuItem_Unpublish) {
            subMenuItems.push(menuItem_Unpublish);
        }

        if (menuItem_VersionAppRej) {
            subMenuItems.push(menuItem_VersionAppRej);
        }

        if (subMenuItems.length > 0) {
            return {
                key: "more",
                disabled: isBusySaving === true,
                text: languageStrings.More,
                // iconProps: { iconName: "MoreVertical" },
                iconProps: {},
                onRenderIcon: () => <MoreVertical20Regular className={menuItemIconStyles} />,
                subMenuProps: {
                    items: subMenuItems
                }
            } as IContextualMenuItem;
        }

        return null;
    }, [menuItem_Checkout, menuItem_Checkin, menuItem_DiscardCheckout, menuItem_Publish, menuItem_Unpublish, menuItem_VersionAppRej, isBusySaving, languageStrings]);

    return {
        menuItem_More
    }

}